define([
    'jQuery',
    'underscore'
],
    function($, _) {

        var Breadcrumbs = function () {

            // breadcrumbs container(s)
            this.elements = $('[data-fcse-role="breadcrumbs--container"]');
        };

        Breadcrumbs.prototype = $.extend({
            /**
             * Update breadcrumbs
             * @param params
             * @private
             */
            update: function (html) {
                if (!_.isUndefined(html)) {
                    this.elements.html(html);
                }
            }
        });

        return Breadcrumbs;
    }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/breadcrumbs/breadcrumbs.js